/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
const colors = {
    transparent: 'transparent',
    current: 'currentColor',
    white: '#FFFFFF',

    null: 'transparent',

    black: {
        10: '#F1F1F1',
        20: '#D4D4D4',
        30: '#B8B8B8',
        40: '#9C9C9C',
        50: '#808080',
        60: '#636363',
        70: '#474747',
        80: '#2A2A2A',
        90: '#0E0E0E',
        100: '#000000',
    },

    'brand-primary': {
        60: '#99D6EA',
        80: '#0084D4',
        100: '#004EA8',
    },

    'brand-secondary': {
        60: '#FABBCB',
        80: '#FF808B',
        100: '#F4364C',
    },

    'brand-tertiary': {
        60: '#8FE2B0',
        80: '#48D597',
        100: '#00C389',
    },

    'brand-quaternary': {
        60: '#F8E08E',
        80: '#FFCD00',
        100: '#FFB600',
    },

    danger: {
        60: '#FEF2F3',
        80: '#FFA2AB',
        100: '#DE1C2F',
    },

    success: {
        60: '#EAFEE7',
        80: '#6BF462',
        100: '#0F8A0F',
    },

    borderLight: '#D4D4D4',
    overlayBackgroundModal: 'rgba(0, 0, 0, 0.75)',
    imageBackground: 'rgba(0,0,0,.05)',
    'accessibility-blue-light': '#15D6EA',
    'accessibility-blue-dark': '#1B96FF',
}

export default colors
